module.exports = __webpack_public_path__ + "img/zixun.0289839f.png";